<div
  class="ordersummary-header adjustjustified"
  [ngClass]="isFromIRScreen === true ? 'irScreen' : ''">
  <div class="row cdi-header-top-row">
    <div class="col-md-8">
      <div class="cdi-header-info row align-items-baseline">
        <div class="col-md-8">
          <h3>
            PO# : <a class="link" (click)="onPreview()">{{ poNumber }}</a>
          </h3>
          <span
            ><h3>{{ vendorName }} - {{ vendorNumber }}</h3></span
          >
        </div>
        <div class="col-md-4">
          <h3 class="reason-text delcol">Reason: {{ reason }}</h3>
        </div>
        <!-- <span
          ><h2>CDI : {{ cdi }}</h2></span
        > -->
      </div>
    </div>
    <!-- <div class="col-md-2">
      <p class="reason-text">Reason : {{ reason }}</p>
    </div> -->
    <div class="col-md-4">
      <div class="row actionselector">
        <div class="ordersummary-status ordersummary-col">
          <label>Please select action</label>
          <p-select
            (onChange)="cdiActionOnChangeEvent()"
            [(ngModel)]="cdiActionVal"
            [options]="cdiAction"
            optionLabel="value"
            optionValue="name"
            [filter]="true"
            [showClear]="true">
          </p-select>
        </div>
      </div>
    </div>
  </div>

  <div class="row align-items-center grid-alignment">
    <div class="col-md-6">
      <span class="cdi-header-info order-num-info">
        <span>
          <h3>
            Order :
            <a class="link" (click)="redirectToSummary(saleOrderId)">{{
              saleOrderId
            }}</a>
          </h3>
        </span>
        <span>
          <h3>{{ customerName }} - {{ jobNameHeader }}</h3>
        </span>
      </span>
    </div>
    <div class="col-md-2"></div>
    <div class="col-md-4">
      <div class="ordersummary-status ordersummary-col text-end actionselector">
        <!-- <button
          type="button"
          class="actionsubmitter"
          [ngClass]="{
            actionsubmittergreen: submitColorChange,
            'disabled-btn': isDisableSubmit,
          }"
          [disabled]="isDisableSubmit"
          (click)="onCdiActionSubmit()">
          Submit
        </button> -->

        <p-button
          label="Submit"
          type="button"
          class="actionsubmitter"
          [ngClass]="{
            actionsubmittergreen: submitColorChange,
            'disabled-btn': isDisableSubmit,
          }"
          [disabled]="isDisableSubmit"
          (click)="onCdiActionSubmit()" />
      </div>
    </div>
  </div>
</div>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="orderDisplayModal"
  [displayModal]="orderDisplayModal"
  (closeEvent)="closeModalForSaleOrder()">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      [saleOrderIdFromModal]="saleOrderId"
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (closeOrderSummaryModalEvent)="
        closeModalForSaleOrder()
      "></jni-order-summary>
  </div>
</jni-modal-stacker>
